import { Map as IMap } from 'immutable';
import { compose } from 'redux';
import { combineReducers } from 'redux-immutable';
import { mergePersistedState } from 'redux-localstorage';
import { intlReducer } from 'react-intl-redux';
import { reducer as baseCapiReducer } from 'capi/redux/immutable';

import sessionReducer, {
    capiCallReducer,
    isGridViewHomePageReducer, sessionLifetimeDeserializer
} from '../session/sessionModule';
import { getCapiUrl, getOrderingToken } from './bootstrap';
import { getNowTimestamp } from '../utils/timeUtils';
import brandReducer from '../brand/brandModule';
import { iovationReducer } from '../iovation/iovationModule';
import routingReducer from '../routing/routingModule';
import faceplateReducer from '../landingPage/landingPageModule';
import paymentReducer from '../payment/paymentModule';
import productCartReducer from '../productCartHandler/productCartModule';
import cartReducer from '../cart/cartModule';
import feeReducer from '../fees/consumerFeeModule';
import purchaseTypeReducer from '../segment/segmentModule';
import loadingReducer from '../loader/loaderModule';
import webViewReducer from '../webView/webViewModule';
import currencyPickerReducer from '../localeCurrencyPicker/LocaleCurrencyPickerModule';
import promoReducer from '../promo/promoModule';
import loyaltyReducer from '../loyalty/loyaltyModule';
import { shippingMethodReducer } from '../shipping/shippingModule';
import addressReducer from '../address/addressModule';
import { senderReducer } from '../payment_v2/senderModule';
import consentReducer from '../payment_v2/consentModule';
import { flowProgressReducer } from '../routing/flowProgressModule';
import unsubscribeReducer from '../unsubscribe/unsubscribeModule';
import authReducer from '../auth/authModule';

export const capiInitialState = IMap({
    url: getCapiUrl(),
    token: getOrderingToken()
});


export const capiReducer = (state = capiInitialState, action) => baseCapiReducer(state, action);





export const lastActionReducer = () => getNowTimestamp();

const appReducer = combineReducers({
    brand: brandReducer,
    capi: capiReducer,
    session: sessionReducer,
    iovation: iovationReducer,
    lastAction: lastActionReducer,
    intl: intlReducer,
    faceplateInfo: faceplateReducer,
    routing: routingReducer,
    payment: paymentReducer,
    addedProducts: productCartReducer,
    cart: cartReducer,
    fees: feeReducer,
    loader: loadingReducer,
    webView: webViewReducer,
    currencyPicker: currencyPickerReducer,
    promo: promoReducer,
    purchaseType: purchaseTypeReducer,
    loyalty: loyaltyReducer,
    sender: senderReducer,
    capiCall: capiCallReducer,
    isGridViewHomePage: isGridViewHomePageReducer,
    shippingMethods: shippingMethodReducer,
    addresses: addressReducer,
    consent: consentReducer,
    flowProgress: flowProgressReducer,
    unsubscribe: unsubscribeReducer,
    auth: authReducer
});

const reducers = compose(
    mergePersistedState(sessionLifetimeDeserializer)
)(appReducer);

export default reducers;
